<template>
  <div class="inline-flex gap-4 items-center w-80 h-20 sm:w-[25vw] sm:h-20 border bg-white rounded-lg">

    <div class="ml-3 sm:w-16 sm:h-16 w-11 h-11 rounded-lg overflow-hidden flex items-center justify-center flex-shrink-0 bg-gray-100">
        <UnLazyImage
          :src="logo"
          class="w-full h-full object-cover"
          @error="setDefaultImage"
      />
      </div>


    <div class="flex-1 flex flex-col justify-between sm:pl-4 pl-0">
      <p class="text-gray-700 font-semibold sm:text-sm text-xs">{{ item.provider.name.length > 42 ? item.provider.name.slice(0, 42) + '...' : item.provider.name }}</p>

      <div class="inline-flex items-center gap-1">
        <p class="sm:text-sm text-xs text-primary cursor-pointer" @click="goToStore">View Menu</p>
        <UIcon name="i-heroicons-chevron-right" class="text-primary sm:text-sm text-xs" />
      </div>
    </div>

    <div class="flex flex-col justify-between items-center">
      <p class="text-xs sm:text-sm text-gray-600">{{ itemCount }} item(s)</p>
      <UButton color="primary" size="xs" label="View Cart" block @click="goToCart" />
    </div>

    <div class="flex-shrink-0 cursor-pointer mr-2" @click="close">
      <V3ImageComponent src="icons/close.png" class="h-4 w-4 filter grayscale" />
    </div>
  </div>
</template>

<script setup>
import { V3ModalComponent, V3PopupComponent } from '#components';

const props = defineProps(['itemsCount']);
const itemCount = props.itemsCount;
const slideover = useSlideover();
const modal = useModal();
const { isMobile } = useDevice();
const getCartItems = localStorage.getItem('cart');
const cartItems = JSON.parse(getCartItems);
const item = cartItems.items[0];
const location = useLocation();
const isLocationAvailable = computed(() => location.isGPSEnabled);
const emit = defineEmits(['close']);
const close = () => emit('close');

const logo = useSecureImage(item?.provider?.images?.thumbnail || item?.provider?.images?.gallery[0] || undefined);
  const setDefaultImage = (event) => {
    event.imageSrc = runtimeConfig.public.defaultImage;
  }

const goToStore = () => {
  const providerId = item.provider?.ukid;
  navigateTo({ path: `/providers/${providerId}` });
};

const goToCart = () => {
  if (!isLocationAvailable) {
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: 'location',
        closable: false,
        onSuccess: () => navigateTo({ path: '/cart' }),
        onClose: slideover.close
      });
    } else {
      modal.open(V3ModalComponent, {
        component: 'location',
        closable: false,
        onSuccess: () => navigateTo({ path: '/cart' }),
        onClose: modal.close
      });
    }
  } else {
    navigateTo({ path: '/cart' });
  }
};
</script>